import BaseAPI from "../api";

const path: string = "positions";

export interface positionTableType {
  keyword?: string;
  limit?: number;
  page?: number;
}
export interface updatePositionType {
  positionName: string;
  status: string;
}
export interface createPositionType {
  positionName: string;
  status: string;
}

export class PositionsApi extends BaseAPI {
  public static createPosition(props: createPositionType): Promise<any> {
    return this.api.post(`${path}`, props).then((res) => res);
  }
  public static getPosition(props: positionTableType): Promise<any> {
    return this.api.get(`${path}`, { params: { ...props } }).then((res) => res);
  }
  public static updatePosition(
    id: number,
    props: updatePositionType
  ): Promise<any> {
    return this.api.patch(`${path}/${id}`, props).then((res) => res);
  }
}
